import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { TeamOwner, UserOwner } from '@/entities/owner/domain/types';

type TeamSearchResponse = {
  hits: {
    total: {
      value: number;
    };
    hits: Array<{
      _source: TeamOwner;
    }>;
  };
};

type UserSearchResponse = {
  hits: {
    total: {
      value: number;
    };
    hits: Array<{
      _source: UserOwner;
    }>;
  };
};

export const fetchTeamOwners = async (): Promise<TeamOwner[]> => {
  try {
    const response = await openMetadataApiClient.get<TeamSearchResponse>('/search/query', {
      params: {
        q: '** AND teamType:Group',
        from: 0,
        size: 100,
        index: 'team_search_index',
        deleted: false,
        sort_field: 'displayName.keyword',
        sort_order: 'asc',
      },
    });
    return response.data.hits.hits.map((hit) => hit._source);
  } catch (error) {
    console.error('Failed to fetch team owners:', error);
    throw error;
  }
};

export const fetchUserOwners = async (): Promise<UserOwner[]> => {
  try {
    const response = await openMetadataApiClient.get<UserSearchResponse>('/search/query', {
      params: {
        q: '** AND isBot:false',
        from: 0,
        size: 100,
        index: 'user_search_index',
        deleted: false,
        sort_field: 'displayName.keyword',
        sort_order: 'asc',
      },
    });
    return response.data.hits.hits.map((hit) => hit._source);
  } catch (error) {
    console.error('Failed to fetch user owners:', error);
    throw error;
  }
};
